module.exports = __webpack_public_path__ + "img/register-button.af423b6c.png";